<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="
        (form) => {
          this.searchForm = form;
        }
      ">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="订单编号" fieldDecoratorId="order_no">
              <a-input placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="供应商" fieldDecoratorId="supplier_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in suppliers" :key="item.id">{{
                    item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                    item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="订单状态" fieldDecoratorId="state">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :value="1">在途</a-select-option>
                <a-select-option :value="2">到店上架中</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="入库类型" fieldDecoratorId="type">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :value="0">采购</a-select-option>
                <a-select-option :value="1">调拨</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="是否超时" fieldDecoratorId="is_overtime">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :value="0">全部</a-select-option>
                <a-select-option :value="1">已超时</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table ref="table" :columns="columns" :data="loadData">
      <template slot="logistics_no" slot-scope="text">
        <span v-if="text">{{ text }}</span>
        <span v-else>--</span>
      </template>
      <template slot="state" slot-scope="text">
        {{ text | SorderStateFilter }}
      </template>
      <template slot="type" slot-scope="text">
        {{ text | purchaseTypeStr }}
      </template>
      <template slot="branch_name" slot-scope="text, record">
        <span v-if="record.type == 0 || record.type == 1">{{ text }}</span>
        <span v-else>{{ text + "," + record.purchase_order_move_record.map(item=>item.branch_name).join(",")}}</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleView(record)">收货</a>
          <a-divider type="vertical" />
          <a @click="moveView(record)" v-if="(record.type == 0 || record.type == 2)">{{ record.type == 0 ? '订单调拨' :
              '调拨信息'
          }}</a>
          <a-divider type="vertical" v-if="(record.type == 0 || record.type == 2)" />
          <!-- <a v-if="record.state < 3" @click="handleNormal(record)">到货正常</a>
          <a v-else @click="handleComplete(record)">处理完毕</a> -->
          <a @click="handleComplete(record)">处理完毕</a>
          <a-divider type="vertical" />
          <!-- <a @click="handleAbnormal(record)">到货异常</a>
          <a-divider type="vertical" /> -->
          <a @click="handleViewRemark(record)">查看备注</a>
        </div>
      </template>
      <template slot="showdetail" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleShowDetail(record)" style="margin-right:4px;">查看</a>
          <a-popover placement="right">
            <template slot="content">
              <span>{{ isOverTime(record.created) ? remainingTime(record.created) : '已超时' }}</span>
            </template>
            <a-progress type="circle" :percent="datePercent(record.created)" :width="32"
              :status="isOverTime(record.created) ? 'normal' : 'exception'" />
          </a-popover>

        </div>
      </template>
    </s-table>
    <a-modal :visible="move.visible" title="订单调拨" @ok="move.visible = false" @cancel="move.visible = false"
      :maskClosable="false" width="700px">
      <a-row style="line-height:32px;">
        <a-col :span="3">
          调出门店：
        </a-col>
        <a-col :span="21">
          {{ move.branchName }}
        </a-col>
        <a-col :span="3">
          订单编号：
        </a-col>
        <a-col :span="21">
          {{ move.orderNo }}
        </a-col>
        <a-col :span="3">
          总件数：
        </a-col>
        <a-col :span="21">
          {{ move.packageQuantity }}
        </a-col>
        <a-col :span="3">
          钉钉单号：
        </a-col>
        <a-col :span="21">
          <a-input v-if="move.isSetDingTalkOrderNo" style="width:180px;" v-model="move.inputDingTalkOrderNo" />
          <span v-else>{{ move.dingTalkOrderNo || "--" }}</span>
          <a-button type="primary" v-if="!move.isSetDingTalkOrderNo"
            @click="move.inputDingTalkOrderNo = move.dingTalkOrderNo; move.isSetDingTalkOrderNo = true"
            style="margin-left:8px">修改</a-button>
          <a-button type="primary" v-if="move.isSetDingTalkOrderNo" style="margin-left:8px"
            :loading="move.setDingTalkOrderNoLoading" @click="setDingTalkOrderNo">修改</a-button>
          <a-button v-if="move.isSetDingTalkOrderNo" style="margin-left:8px" @click="move.isSetDingTalkOrderNo = false">
            取消</a-button>
        </a-col>
        <a-col :span="3" style="margin:12px 0">
          调拨：
        </a-col>
        <a-col :span="10" style="margin:12px 0">
          <a-select placeholder="请选择要调入的门店" v-model="move.outBranchID" style="width:95%;">
            <a-select-option v-for="item in branches" :key="item.id" v-if="item.name != move.branchName">{{
                item.name
            }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="5" style="margin:12px 0">
          <a-input-number placeholder="请输入调拨数量" :min="1" :max="move.packageQuantity" style="width:90%;"
            v-model="move.quantity" />
        </a-col>
        <a-col :span="5" style="margin:12px 0">
          <a-popconfirm placement="rightTop" ok-text="确定" cancel-text="取消" @confirm="addPurchaseMoveRecord">
            <template slot="title">
              <p>是否确认调拨？</p>
            </template>
            <a-button type="primary" :loading="move.moveLoading">新增调拨</a-button>
          </a-popconfirm>
          
        </a-col>
        <a-col :span="24">
          <s-table ref="move" :data="getPurchaseMoveRecord" :columns="moveTableColumns" :pageSize="10"></s-table>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal :visible="previewVisible" :footer="null" size="middle" @cancel="previewVisible = false">
      <div class="item">
        <label>物流信息:</label><span>{{ this.company }}</span>
      </div>
      <img alt="example" style="width: 100%" :src="previewImages" />
    </a-modal>
    <a-modal title="到货异常原因" :visible="visible" @ok="_handleOk" @cancel="handleCancel" :maskClosable="false">
      <a-textarea :rows="3" v-model.number="currentRecord.cause" placeholder="请填写到货异常原因" />
      <div class="tips">
        <p>请根据到货情况填写异常原因，例如:</p>
        <p>订单编号：220174745</p>
        <p>SKU:123456789</p>
        <p>异常原因：应到10个,实际到货5个,已收货上架5个</p>
        <p>还有到了一个不认识的礼品15个【上传图片】</p>
        <p>请采购同事联系厂商并备注告知门店处理结果以及后续如何处理该笔订单</p>
      </div>
    </a-modal>
    <a-modal title="订单备注" :visible="remarkVisible" @ok="handleSaveRemark" @cancel="handleCancelRemark"
      :maskClosable="false">
      <s-table ref="remark" :columns="remarkColums" :data="loadRemarkData" :pageSize="5">
        <template slot="remarkType" slot-scope="text">
          {{ text === 1 ? "门店留言" : "采购留言" }}
        </template>
      </s-table>
      <a-textarea :rows="3" v-model.number="currentRecord.cause" placeholder="请填写到货异常原因" />
      <div class="tips">
        <p>请根据到货情况填写异常原因，例如:</p>
        <p>订单编号：220174745</p>
        <p>SKU:123456789</p>
        <p>异常原因：应到10个,实际到货5个,已收货上架5个</p>
        <p>还有到了一个不认识的礼品15个【上传图片】</p>
        <p>请采购同事联系厂商并备注告知门店处理结果以及后续如何处理该笔订单</p>
      </div>
    </a-modal>
    <a-modal title="确认收货" :width="600" v-model="arrival.visible" okText="确认收货" @ok="handleArrival(arrival)"
      @cancel="arrival.visible = false">
      <a-row style="line-height:32px;">
        <a-col :span="4">
          订单编号：
        </a-col>
        <a-col :span="20">
          {{ arrival.orderNo }}
        </a-col>
        <a-col :span="4">
          订单类型：
        </a-col>
        <a-col :span="20">
          {{ arrival.orderType }}
        </a-col>
        <a-col :span="4">
          归属门店：
        </a-col>
        <a-col :span="20">
          {{ arrival.branchName }}
        </a-col>
        <a-col :span="4">
          订单件数：
        </a-col>
        <a-col :span="20">
          {{ arrival.packageQuantity }}
        </a-col>
        <a-col :span="4">
          物流单号：
        </a-col>
        <a-col :span="20">
          {{ arrival.logistics_no }}
        </a-col>
      </a-row>
    </a-modal>

    <a-modal title="异常到货" :width="500" v-model="complete.visible" okText="确认"
      @ok="handleAbnormalComplete(complete.orderID)" @cancel="complete.visible = false">
      <a-row style="line-height:32px;">
        <a-col :span="4">
          订单编号：
        </a-col>
        <a-col :span="20">
          {{ complete.orderNo }}
        </a-col>
        <a-col :span="4">
          订单类型：
        </a-col>
        <a-col :span="20">
          {{ complete.orderType }}
        </a-col>
        <a-col :span="4">
          归属门店：
        </a-col>
        <a-col :span="20">
          {{ complete.branchName }}
        </a-col>
        <a-col :span="24">
          提示：本订单还存在剩余未上架或超量上架商品，请确定已经将该笔订单的所有包裹拆开无遗漏，该笔订单确实存在异常情况，点击确定后，该笔订单不可再次操作！
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getWayallstock, updateAllstock, getRemarkList, getPurchaseIsNormal, purchaseComplete } from "@/api/stock";
import { purchaseArrival, setPurchaseDingTalkOrderNo, getPurchaseMoveRecord, addPurchaseMoveRecord } from "@/api/purchase"
import { mixinGetBranchList, mixinGetSupplierList } from "@/mixins";
import Vue from 'vue';

function getOrderTime(dateStr, nowTime) {
  let orderTime = new Date(dateStr).getTime(),
    overTimeLength = 240 * 60 * 60 * 1000,
    overTime = nowTime - overTimeLength
  return {
    orderTime,
    overTimeLength,
    overTime
  }
}
export default {
  name: "WayGoods",
  mixins: [mixinGetBranchList, mixinGetSupplierList],
  components: {
    STable,
  },
  data() {
    return {
      complete: {
        visible: false,
        orderID: "",
        orderNo: "",
        orderType: "",
        branchName: "",
      },
      move: {
        visible: false,
        list: [],
        orderNo: "",
        dingTalkOrderNo: "",
        inputDingTalkOrderNo: "",
        setDingTalkOrderNoLoading: false,
        isSetDingTalkOrderNo: false,
        packageQuantity: 0,
        branchName: "",
        outBranchID: undefined,
        quantity: undefined,
        moveLoading: false,
      },
      moveTableColumns: [
        {
          title: "调拨时间",
          dataIndex: "created",
        },
        {
          title: "调入门店",
          dataIndex: "branch_name",
        },
        {
          title: "调拨数量",
          dataIndex: "package_quantity",
        },
      ],
      arrival: {
        visible: false,
        state: null,
        orderID: "",
        orderNo: "",
        orderType: "",
        branchName: "",
        logistics_no: "",
        packageQuantity: "",
        loading: false
      },
      nowTime: new Date().getTime(),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      // 查询参数
      loading: false,
      searchForm: null,
      previewVisible: false,
      currentRecord: {},
      previewImages: "",
      company: "",
      queryParam: {},
      visible: false,
      columns: [
        {
          title: "物流号码",
          dataIndex: "logistics_no",
          scopedSlots: { customRender: "logistics_no" },
        },
        {
          title: "订单编号",
          dataIndex: "order_no",
        },
        // {
        //   title: '供应商',
        //   dataIndex: 'supplier_name',
        // },
        {
          title: "订单类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "订单时间",
          dataIndex: "created",
        },
        {
          title: "采购人",
          dataIndex: "admin_user_name",
        },
        {
          title: "供应商",
          dataIndex: "supplier_name"
        },
        {
          title: "归属门店",
          dataIndex: "branch_name",
          scopedSlots: { customRender: "branch_name" },
        },
        {
          title: "订单总件数",
          dataIndex: "package_quantity",
        },
        {
          title: "订单状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
        },
        // {
        //   title: "备注",
        //   dataIndex: "remark",
        // },
        // {
        //   title: "异常原因",
        //   dataIndex: "cause",
        // },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
        {
          title: "操作日志",
          dataIndex: "showDetail",
          width: 100,
          scopedSlots: { customRender: "showdetail" },
        },
      ],
      remarkVisible: false,
      remarkColums: [
        {
          title: "备注类型",
          dataIndex: "type",
          scopedSlots: { customRender: "remarkType" },
        },
        {
          title: "备注内容",
          dataIndex: "content",
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getWayallstock(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
      loadRemarkData: (params) => {
        if (this.currentRecord && this.currentRecord.id) {
          console.log(params);
          return getRemarkList(
            { page: 1, page_size: 5, ...params },
            this.currentRecord.id
          ).then((res) => res);
        }
        return Promise.resolve([]);
      },
      getPurchaseMoveRecord: (params) => {
        return getPurchaseMoveRecord(this.move.id, params).then((res) => res)
      }
    };
  },
  methods: {
    moveView(record) {
      this.move = {
        visible: true,
        id: record.id,
        list: [],
        orderNo: record.order_no,
        branchName: record.branch_name,
        dingTalkOrderNo: record.ding_talk_order_no,
        inputDingTalkOrderNo: record.ding_talk_order_no,
        setDingTalkOrderNoLoading: false,
        isSetDingTalkOrderNo: false,
        packageQuantity: record.package_quantity,
        outBranchID: undefined,
        quantity: undefined,
        moveLoading: false,
      }

    },
    setDingTalkOrderNo() {
      this.move.setDingTalkOrderNoLoading = true
      let inputDingTalkOrderNo = this.move.inputDingTalkOrderNo
      console.log({
        id: this.move.id,
        ding_talk_order_no: inputDingTalkOrderNo,
      })
      setPurchaseDingTalkOrderNo({
        id: this.move.id,
        ding_talk_order_no: inputDingTalkOrderNo,
      })
        .then(() => {
          this.$message.success("操作成功");
          this.move.dingTalkOrderNo = inputDingTalkOrderNo
          this.move.isSetDingTalkOrderNo = false
          this.$refs.table.refresh();
        })
        .finally(() => {
          this.move.setDingTalkOrderNoLoading = false
        })
    },
    addPurchaseMoveRecord() {
      this.move.moveLoading = true
      addPurchaseMoveRecord({
        id: this.move.id,
        branch_id: this.move.outBranchID,
        package_quantity: this.move.quantity
      })
        .then(res => {
          this.$message.success("操作成功");
          this.$refs.table.refresh();
          this.$refs.move.refresh();
        })
        .finally(() => {
          this.move.moveLoading = false
        })
    },
    datePercent(dateStr) {
      let {
        orderTime,
        overTimeLength,
        overTime
      } = getOrderTime(dateStr, this.nowTime)
      if (overTime > orderTime) {
        return 0
      } else {
        return parseInt(((orderTime - overTime) / overTimeLength) * 100)
      }
    },
    isOverTime(dateStr) {
      let {
        orderTime,
        overTime
      } = getOrderTime(dateStr, this.nowTime)
      return overTime < orderTime
    },
    remainingTime(dateStr) {
      let {
        orderTime,
        overTime
      } = getOrderTime(dateStr, this.nowTime)
      return `剩余${parseInt((orderTime - overTime) / 60 / 60 / 1000)}个小时`
    },
    handleArrival(arrival) {
      arrival.visible = false
      purchaseArrival(arrival.orderID)
        .then(() => {
          this.$message.success("操作成功");
          this.$refs.table.refresh();
        })
    },
    handleNormal(row) {
      const params = {
        id: row.id,
        state: 2,
      };
      updateAllstock(params).then((res) => {
        this.$message.success("操作成功");
        this.$refs.table.refresh();
      });
    },
    handleComplete(row) {
      getPurchaseIsNormal(row.id).then((res) => {
        if (res.is_normal) {
          this.handleAbnormalComplete(row.id)
        } else {
          this.complete = {
            visible: true,
            orderID: row.id,
            orderNo: row.order_no,
            orderType: Vue.filter("purchaseTypeStr")(row.type),
            branchName: row.branch_name,
          }
        }
      });
      // const params = {
      //   id: row.id,
      //   state: 5,
      // };
      // updateAllstock(params).then((res) => {
      //   this.$message.success("操作成功");
      //   this.$refs.table.refresh();
      // });
    },
    handleAbnormalComplete(id) {
      this.complete.visible = false
      purchaseComplete(id)
        .then(res => {
          this.$message.success("操作成功");
          this.$refs.table.refresh();
        })
    },
    handleAbnormal(row) {
      this.currentRecord = { ...row };
      this.visible = true;
    },
    handleCancel() {
      this.currentRecord = {};
      this.visible = false;
    },
    _handleOk() {
      if (!this.currentRecord.cause) {
        this.$message.error("请填写异常原因");
        return;
      }
      const params = {
        id: this.currentRecord.id,
        cause: this.currentRecord.cause,
        state: 3,
      };
      updateAllstock(params).then((res) => {
        this.$message.success("操作成功");
        this.$refs.table.refresh();
        this.handleCancel();
      });
    },
    handleSearch(e) {
      e.preventDefault();
      this.queryParam = {
        order_no: this.searchForm.getFieldValue("order_no"),
        supplier_id: this.searchForm.getFieldValue("supplier_id"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        state: this.searchForm.getFieldValue("state"),
        type: this.searchForm.getFieldValue("type"),
        is_overtime: this.searchForm.getFieldValue("is_overtime"),
      };
      this.$refs.table.refresh();
    },
    handleReset() {
      this.searchForm.resetFields();
      this.queryParam = {};
      this.$refs.table.refresh();
    },
    handleView(row) {
      if (row.state == 2) {
        let routertwo = this.$router.resolve({
          name: "WayGoodsList",
          params: { id: row.id },
        });
        window.open(routertwo.href, "_blank");
      } else {
        this.arrival = {
          visible: true,
          state: row.state,
          orderID: row.id,
          orderNo: row.order_no,
          orderType: Vue.filter("purchaseTypeStr")(row.type),
          branchName: row.branch_name,
          logistics_no: row.logistics_no,
          packageQuantity: row.package_quantity,
        }
      }
    },
    handleShowDetail(row) {
      let routertwo = this.$router.resolve({
        name: "WayGoodsDetail",
        params: { id: row.id },
      });
      window.open(routertwo.href, "_blank");
    },
    previewImage(record) {
      this.previewImages = record.courier;
      this.company = record.company;
      this.previewVisible = true;
    },
    //订单备注部分
    handleViewRemark(row) {
      this.currentRecord = { ...row };
      this.remarkVisible = true;
      this.$refs.remark.refresh();
    },
    handleSaveRemark() {
      if (!this.currentRecord.cause) {
        this.$message.error("请填写异常原因");
        return;
      }
      const params = {
        id: this.currentRecord.id,
        cause: this.currentRecord.cause,
        state: 3,
      };
      updateAllstock(params).then((res) => {
        this.$message.success("操作成功");
        this.handleCancelRemark();
      });
    },
    handleCancelRemark() {
      this.remarkVisible = false;
      this.currentRecord = {};
    },
  },
};
</script>
<style scoped>
.courier {
  width: 40px;
  height: 40px;
}

.courier>img {
  width: 40px;
  height: 40px;
  display: block;
}

.item {
  padding: 0 0 15px 20px;
}

.item label {
  color: rgba(0, 0, 0, 0.85);
}

.item span {
  margin-left: 15px;
}

.red {
  background: #ff5845;
}

.blue {
  background: #fcfcfc;
}

.tips {
  font-weight: bold;
  margin-top: 20px;
}
</style>
